import React,{useState} from "react";
import ExcelJS from "exceljs";
import {saveAs} from "file-saver";
import toast from "react-hot-toast";
import {downloadSettlementReport} from "api/settlement";
import {LoadingOutlined} from "@ant-design/icons";
import {Spin} from "antd";
import {FaDownload} from "react-icons/fa";
import {Popover,PopoverTrigger,PopoverContent,PopoverHeader,PopoverArrow} from "@chakra-ui/react";
import {Portal} from "@chakra-ui/portal";
import summaryReportExcelSheets from "./settlementReportTypes/summary/summaryReports";
import apmReportsExcelSheets from "./settlementReportTypes/apm/apmTransaction";
import cardTypeVisaReportsExcelSheets from "./settlementReportTypes/cards/CardTypeVisaReports";
import cardTypeDiscoverReportsExcelSheets from "./settlementReportTypes/cards/CardTypeDiscoverReports";
import cardTypeAmexReportsExcelSheets from "./settlementReportTypes/cards/CardTypeAmexReports";
import cardTypeMasterCardReportsExcelSheets from "./settlementReportTypes/cards/CardTypeMasterCardReports";
import refundReportExcelSheets from "./settlementReportTypes/refunded/refundReports";
import cancelReportExcelSheets from "./settlementReportTypes/canceled/cancelReports";
import declinedReportExcelSheets from "./settlementReportTypes/declined/declinedReports";
import disputeReportExcelSheets from "./settlementReportTypes/dispute/disputeReports";
import chargebackReportExcelSheets from "./settlementReportTypes/chargeback/chargebackReports";
import heldReportExcelSheets from "./settlementReportTypes/held/heldReports";
import erroredReportExcelSheets from "./settlementReportTypes/errored/erroredReports";

interface Props{
	ReportData?: any;
  handleDownloadReport?: any;
  settlementInfo?: any;
  fetchAllsettlement?:any;
}

const SettlementReport:React.FC<Props>=({settlementInfo,fetchAllsettlement})=>{
	const[loadingDownload,setLoadingDownload]=useState(false);

	const createExcel=(jsonData:any)=>{
		try{
			if(!jsonData?.settlementReportCanBeGenerated){
				toast.error("Cannot generate settlement report.");
				return;
			}

			const workbook=new ExcelJS.Workbook();

			const templateColor={
				yellow:"b59a67",
				blue:"152046",
				black:"070708",
				white:"f5f5fc"
			};

			summaryReportExcelSheets(jsonData,workbook,templateColor);
			apmReportsExcelSheets(jsonData,workbook,templateColor);
			cardTypeAmexReportsExcelSheets(jsonData,workbook,templateColor);
			cardTypeMasterCardReportsExcelSheets(jsonData,workbook,templateColor);
			cardTypeVisaReportsExcelSheets(jsonData,workbook,templateColor);
			cardTypeDiscoverReportsExcelSheets(jsonData,workbook,templateColor);
			refundReportExcelSheets(jsonData,workbook,templateColor);
			cancelReportExcelSheets(jsonData,workbook,templateColor);
			chargebackReportExcelSheets(jsonData,workbook,templateColor);
			disputeReportExcelSheets(jsonData,workbook,templateColor);
			heldReportExcelSheets(jsonData,workbook,templateColor);
			declinedReportExcelSheets(jsonData,workbook,templateColor);
			erroredReportExcelSheets(jsonData,workbook,templateColor);

			const organizationName=settlementInfo?.row?.original?.organization?.name??"Organization";
			const clientName=settlementInfo?.row?.original?.client?.map((c:any)=>c?.name)?.join(" ")??"Client";
			const paymentMethods=settlementInfo?.row?.original?.payment_methods??[];

			const startDates=paymentMethods.map((p:any)=>p?.starting_date).filter(Boolean);
			const endDates=paymentMethods.map((p:any)=>p?.ending_date).filter(Boolean);

			const startDate=startDates.length>0?startDates.sort()[0]:"";
			const endDate=endDates.length>0?endDates.sort().reverse()[0]:"";

			const dateRange=startDate&&endDate?`${startDate}_to_${endDate}`:"DateRange";

			const safeFileName=`${organizationName} ${clientName} ${dateRange}`.replace(/[^\w\s-]/g,"");

			workbook.xlsx.writeBuffer().then(buffer=>{
				const blob=new Blob([buffer],{type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
				saveAs(blob,safeFileName);
				fetchAllsettlement?.();
			});
		}catch(error){
			toast.error("Failed to generate Excel file.");
		}
	};

	const handleExcelDownload=()=>{
		setLoadingDownload(true);
		downloadSettlementReport(settlementInfo?.row?.original?.id)
		.then(response=>{
			if(response?.settlementReportCanBeGenerated){
				createExcel(response);
			}else{
				toast.error("No transactions available for selected period.");
			}
		})
		.catch(()=>{
			toast.error("Download failed.");
		})
		.finally(()=>{
			setLoadingDownload(false);
		});
	};

	if(loadingDownload){
		return(
			<Spin indicator={<LoadingOutlined style={{fontSize:18}} spin/>}/>
		);
	}

	return(
		<Popover trigger="hover" placement="bottom">
			<PopoverTrigger>
				<button className="st-action-btn st-action-btn--blue" onClick={handleExcelDownload}>
					<FaDownload size={14}/>
				</button>
			</PopoverTrigger>
			<Portal>
				<PopoverContent border="1px solid #bfdbfe" borderRadius="12px" boxShadow="0 8px 24px rgba(15,23,42,0.08)" bg="#eff6ff" maxW="220px" p="0" overflow="hidden" zIndex="20">
					<PopoverHeader bg="#dbeafe" fontSize="12px" fontWeight="700" color="#1d4ed8" borderBottom="1px solid #bfdbfe" px="14px" py="10px">
						Download Settlement Report
					</PopoverHeader>
					<PopoverArrow bg="#eff6ff"/>
				</PopoverContent>
			</Portal>
		</Popover>
	);
};

export default SettlementReport;